import { HD, FULL_HD, IMAGE_FIT_MAX, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../utils/sizes';
import { sizes as heroNavSizes } from './heroNav/heroNav.style';
import { logoSize } from './heroMetadata/customer/default/heroMetadata.constants';

export { sizes as heroNavSizes } from './heroNav/heroNav.style';

export const templates = {
  Hero: 'Hero',
};

export const sizes = {
  [templates.Hero]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: SCREEN_WIDTH[HD],
        h: Math.round(SCREEN_HEIGHT[HD] * 0.85),
      },
      [FULL_HD]: {
        w: SCREEN_WIDTH[FULL_HD],
        h: Math.round(SCREEN_HEIGHT[FULL_HD] * 0.85),
      },
    },
  },
};

export const imageOptions = {
  [templates.Hero]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: SCREEN_WIDTH[HD],
          height: SCREEN_HEIGHT[HD],
        },
        SECONDARY: {
          width: heroNavSizes[HD].w,
          height: heroNavSizes[HD].h,
        },
        LOGO: {
          width: logoSize[HD].w,
          height: logoSize[HD].h,
          fit: IMAGE_FIT_MAX,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: SCREEN_WIDTH[FULL_HD],
          height: SCREEN_HEIGHT[FULL_HD],
        },
        SECONDARY: {
          width: heroNavSizes[FULL_HD].w,
          height: heroNavSizes[FULL_HD].h,
        },
        LOGO: {
          width: logoSize[FULL_HD].w,
          height: logoSize[FULL_HD].h,
          fit: IMAGE_FIT_MAX,
        },
      },
    },
  },
};
